const Config = {
  network: {
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000',
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1/',
    wsUrl: process.env.REACT_APP_WS_URL || 'ws://localhost:8000'
  },
  layout: {
    xs: 0,
    sm: 620,
    md: 960,
    xm: 1140,
    lg: 1340,
    xl: 1550,
    fullHd: 1920
  },
  contacts: {
    contactEmail: process.env.REACT_APP_CONTACT_EMAIL || 'contact@regul.app',
    supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@regul.app',
    termsUrl: process.env.REACT_APP_TERMS_URL || 'https://www.regul.app/legal-texts/terms-of-use',
    policyUrl: process.env.REACT_APP_POLICY_URL || 'https://www.regul.app/legal-texts/privacy-policy',
    websiteUrl: process.env.REACT_APP_WEBSITE_URL || 'https://www.regul.app',
  },
  pestel: {
    // Standalone PESTEL app. Configurable via env; defaults to pestel.regul.app.
    url: process.env.REACT_APP_PESTEL_URL || 'https://pestel.regul.app'
  }
}

export default Config
